import React, { useEffect, useState } from "react";
import {
  Box,
  Stack,
  Button,
  FormControlLabel,
  IconButton,
  Snackbar,
  Alert,
  Checkbox,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CreatableSelect from "react-select/creatable";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTextInput from "../components/common/custom-input/CustomInput";
import { supabaseClient } from "../utils/config";
import axios from "axios";

function SelectRecepient() {
  const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  const navigate = useNavigate();

  const [subject, setSubject] = useState("");
  const [recepient, setRecepient] = useState([]);
  const [html, setHtml] = useState("");
  const [waitlist, setWaitlist] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState({});
  const [availableGroups, setAvailableGroups] = useState([]);
  const [displayNotification, setDisplayNotification] = useState(false);
  const location = useLocation();

  const fetchGroups = async () => {
    try {
      const { data, error } = await supabaseClient
        .from("waitlist")
        .select("group");

      if (error) {
        console.error("Error fetching groups:", error);
        setAvailableGroups([]);
        return;
      }

      const uniqueGroups = [
        ...new Set(
          data
            .map((item) => item.group)
            .filter((group) => group !== null && group !== "")
        ),
      ];

      setAvailableGroups(uniqueGroups);

      const initialSelected = {};
      uniqueGroups.forEach((groupName) => {
        initialSelected[groupName] = false;
      });
      setSelectedGroups(initialSelected);
    } catch (err) {
      console.error("Error in fetchGroups:", err);
      setAvailableGroups([]);
    }
  };

  useEffect(() => {
    if (location.state?.html) {
      setHtml(location.state.html);
    }
    fetchGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGroupChange = (groupName) => {
    setSelectedGroups((prev) => ({
      ...prev,
      [groupName]: !prev[groupName],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!subject || subject.trim() === "") {
      alert("Please enter a subject");
      return;
    }

    if (!html || html.trim() === "") {
      alert("No email template found. Please go back and create a template first.");
      return;
    }

    const selectedGroupNames = Object.keys(selectedGroups).filter(
      (groupName) => selectedGroups[groupName]
    );

    if (!waitlist && selectedGroupNames.length === 0 && (!recepient || recepient.length === 0)) {
      alert("Please select at least one recipient option (Waitlist, Internal, or add custom emails)");
      return;
    }

    const mailData = {
      otherEmails: recepient?.map((item) => item?.label) || [],
      subject: subject,
      waitlist: waitlist,
      selectedGroups: selectedGroupNames,
      emailTemplate: html,
    };
    
    const baseUrl = process.env.REACT_APP_SERVER_URL;
    const apiUrl = baseUrl.endsWith("/") 
      ? `${baseUrl}email/send-bulk` 
      : `${baseUrl}/email/send-bulk`;
    
    axios
      .post(apiUrl, mailData)
      .then((response) => {
        console.log("Email sent successfully:", response.data);
        setDisplayNotification(true);
      })
      .catch((error) => {
        console.error("Error sending email:", error);
        console.error("Error response:", error?.response?.data);
        console.error("Error status:", error?.response?.status);
        alert(`Failed to send email: ${error?.response?.data?.message || error.message}`);
      });
  };

  return (
    <Box sx={{ height: "100vh" }}>
      <Snackbar
        open={displayNotification}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setDisplayNotification(false)}
        message={"Email Sent Successfully!"}
      >
        <Alert
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
          onClose={() => setDisplayNotification(false)}
        >
          Email Sent Successfully
        </Alert>
      </Snackbar>
      <Box
        sx={{
          width: "70%",
          height: "calc(100vh - 20px)",
          margin: "auto",
          marginTop: "20px",
          paddingTop: "10vh",
          backgroundColor: "#fff",
          borderRadius: 3,
        }}
      >
        <IconButton sx={{ marginLeft: 10 }} onClick={() => navigate(-1)}>
          <ArrowBackIcon height={100} />
        </IconButton>
        <form onSubmit={handleSubmit}>
          <Stack
            spacing={4}
            textAlign={"center"}
            sx={{ margin: "auto !important", width: "80%" }}
          >
            <CustomTextInput
              label="Subject"
              value={subject}
              onChange={(event) => {
                setSubject(event.target.value);
              }}
              required
              sx={{ marginTop: "30px" }}
            />

            <CreatableSelect
              isMulti
              name="Select Recepient"
              options={recepient}
              onChange={setRecepient}
              closeMenuOnSelect={false}
              isValidNewOption={(inputValue) => {
                const isValidEmail = emailRegex.test(inputValue);
                return isValidEmail;
              }}
            />

            <Stack
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={waitlist}
                    onChange={() => {
                      setWaitlist(!waitlist);
                    }}
                  />
                }
                style={{ color: "black" }}
                label="Waitlist"
              />

              {availableGroups.map((groupName) => (
                <FormControlLabel
                  className="capitalize"
                  key={groupName}
                  control={
                    <Checkbox
                      checked={selectedGroups[groupName] || false}
                      onChange={() => handleGroupChange(groupName)}
                    />
                  }
                  style={{ color: "black" }}
                  label={groupName}
                />
              ))}
            </Stack>
            <Box>
              <Button
                type="submit"
                sx={{
                  backgroundColor: "#069d6e",
                  color: "white",
                  width: 200,
                  height: 50,
                  "&:hover": {
                    backgroundColor: "#069d6e",
                    color: "white",
                  },
                }}
              >
                Send
              </Button>
            </Box>
          </Stack>
        </form>
      </Box>
    </Box>
  );
}

export default SelectRecepient;
